
import getConfigFB from "./ConfigFB";


class DynamicLinkHelper{

    shortLink = null;

    constructor(shareDocID){        
        this.longLink = this.getLongDynamicLink(shareDocID);
        this.createShortLink(); //create async.    
    }

    getLongDynamicLink(shareDocID){
        let linkBegin;
        if (window.location.hostname === 'dev-points.serban.pw' || window.location.hostname === 'localhost'){        
            linkBegin = "https://devpointso.page.link/?amv=40&apn=pw.serban.android.points_o_rama&link=https://dev-points.serban.pw/sharereceive/"

        } else {
            linkBegin = "https://pointsorama.page.link/?amv=40&apn=pw.serban.android.points_o_rama&link=https://points-o-rama.serban.pw/sharereceive/"
        }
        return linkBegin + shareDocID;
    }

    createShortLink(){
        let apiKey = getConfigFB().apiKey;
        const restURL = "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=" + apiKey;

        const postObject = {
            "longDynamicLink": this.longLink,
            "suffix": {
              "option": "UNGUESSABLE"
            }
        }

        fetch(restURL, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(postObject), // body data type must match "Content-Type" header
        })
        .then(response => {
            if (response.ok){
                return response.json();
            } else {
                throw new Error('short link request failed');
            }
        })
        .then((responseJson) => {
            this.shortLink = responseJson.shortLink;
        })
        .catch((error) => {
            console.log(error);
        })
        
         
    }

    getDynamicLink(){
        return this.shortLink ? this.shortLink : this.longLink ;
    }

}

export default DynamicLinkHelper;


// WEBPACK FOOTER //
// ./src/helpers/DynamicLinkHelper.js